import {Component, Input} from '@angular/core';
import {VorhersageMesswerte} from '../../../../../../../../model/vorhersagen/vorhersage-messwerte';
import {DatastoreService} from '../../../../../../../../service/datastore/datastore.service';
import {WerteConverterUtil} from '../../../../../../../../util/werte-converter-util';

@Component({
  selector: 'app-3h-vorhersage-table-detail',
  templateUrl: './drei-stunden-vorhersage-table-detail.component.html',
  styleUrls: ['../../../vorhersagen-table-styles.css']
})
export class DreiStundenVorhersageTableDetailComponent {

  @Input() messwerte: VorhersageMesswerte;

  constructor(public datastoreService: DatastoreService, public  werteConverter: WerteConverterUtil) {
  }

  getQuadratmeter(einheit: string | undefined) {
    return einheit.replace('^2', '²');
  }

}
